import { SEO, breadcrumbSchema } from '../components/SEO';
import { STATIC_SEO } from '../data/seoConfig';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import { ServiceCard } from '../components/cards';
import { Reveal, Stagger, StaggerItem } from '../components/Reveal';
import { SERVICES } from '../data/services';
import { IMAGES } from '../data/site';

const ServicesPage = () => (
  <>
    <SEO
      title={STATIC_SEO.services.title}
      description={STATIC_SEO.services.description}
      path="/services/"
      jsonLd={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Services', path: '/services/' }])]}
    />
    <PageHero
      overline="Our Services"
      title="Custom outdoor living, designed & built"
      intro="Discover our comprehensive range of outdoor living solutions — each one custom-designed for your property and built by one accountable local team."
      image={IMAGES.kitchen}
      breadcrumbs={[{ name: 'Home', path: '/' }, { name: 'Services' }]}
    />
    <section className="py-20 md:py-28">
      <div className="container-site">
        <Stagger className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s) => (
            <StaggerItem key={s.slug}><ServiceCard service={s} /></StaggerItem>
          ))}
        </Stagger>
        <Reveal className="mt-16 max-w-3xl">
          <p className="text-base leading-relaxed text-muted2">
            Not sure where to start? Most of our favorite projects combine several of these services into one cohesive plan. A free consultation is the easiest first step — we will walk your property, listen first, and give you honest guidance.
          </p>
        </Reveal>
      </div>
    </section>
    <CTASection title="Not sure which service fits?" text="Tell us how you want to live outdoors. We'll help you figure out the rest — starting with a free on-site consultation." testId="services-cta" />
  </>
);

export default ServicesPage;
